export default {
  SET_LOADING:         (state, val) => { state.loading = val },
  SET_LOADING_DETALLE: (state, val) => { state.loadingDetalle = val },
  SET_VISTA:           (state, val) => { state.vista = val },

  SET_FILTRO: (state, { campo, valor }) => {
    state.filtros[campo] = valor
  },
  RESET_FILTROS: (state) => {
    state.filtros = { search: '', estado: null, nivel_impacto: null, comunicacion: null, responsable: null }
  },

  // Listado
  SET_INCIDENCIAS:  (state, data) => { state.incidencias = data },
  SET_KPIS:         (state, data) => { state.kpis = data },
  SET_ARBOL:        (state, data) => { state.arbolServicios = data },
  SET_PLANTILLAS:   (state, data) => { state.plantillas = data },
  SET_USUARIOS:     (state, data) => { state.usuariosResponsables = data },

  // Detalle
  SET_DETALLE:      (state, data) => { state.incidenciaDetalle = data },
  SET_TICKETS:      (state, data) => { state.ticketsAsociados = data },
  SET_SEGUIMIENTOS: (state, data) => { state.seguimientos = data },
  SET_COMUNICACIONES: (state, data) => { state.comunicaciones = data },
  SET_AUDITORIA:    (state, data) => { state.historialAuditoria = data },

  // Actualizar una incidencia dentro del listado (ej: al cambiar estado desde kanban)
  UPDATE_INCIDENCIA: (state, incidencia) => {
    if (!state.incidencias?.data) return
    const idx = state.incidencias.data.findIndex((i) => i.id === incidencia.id)
    if (idx !== -1) Object.assign(state.incidencias.data[idx], incidencia)
    // También actualiza el detalle si está cargado
    if (state.incidenciaDetalle?.id === incidencia.id) {
      Object.assign(state.incidenciaDetalle, incidencia)
    }
  },
}
